export function hasZipCodeTaxError(_ref) {
  var _calculationErrors$ta, _calculationErrors$ta2;
  let {
    calculationErrors
  } = _ref;
  return (_calculationErrors$ta = calculationErrors == null || (_calculationErrors$ta2 = calculationErrors.taxCalculationError) == null || (_calculationErrors$ta2 = _calculationErrors$ta2.validationError) == null || (_calculationErrors$ta2 = _calculationErrors$ta2.fieldViolations) == null ? void 0 : _calculationErrors$ta2.some(violationObject => violationObject.field === 'postalCode' && violationObject.description === 'MISSING')) != null ? _calculationErrors$ta : false;
}
export function hasSubdivisionTaxError(_ref2) {
  var _calculationErrors$ta3, _calculationErrors$ta4;
  let {
    calculationErrors
  } = _ref2;
  return (_calculationErrors$ta3 = calculationErrors == null || (_calculationErrors$ta4 = calculationErrors.taxCalculationError) == null || (_calculationErrors$ta4 = _calculationErrors$ta4.validationError) == null || (_calculationErrors$ta4 = _calculationErrors$ta4.fieldViolations) == null ? void 0 : _calculationErrors$ta4.some(violationObject => violationObject.field === 'subdivision' && violationObject.description === 'MISSING')) != null ? _calculationErrors$ta3 : false;
}
export function hasSubdivisionShippingError(_ref3) {
  var _calculationErrors$ca, _calculationErrors$ca2;
  let {
    calculationErrors
  } = _ref3;
  return (_calculationErrors$ca = calculationErrors == null || (_calculationErrors$ca2 = calculationErrors.carrierErrors) == null || (_calculationErrors$ca2 = _calculationErrors$ca2.errors) == null ? void 0 : _calculationErrors$ca2.some(_ref4 => {
    var _error$validationErro;
    let {
      error
    } = _ref4;
    return error == null || (_error$validationErro = error.validationError) == null || (_error$validationErro = _error$validationErro.fieldViolations) == null ? void 0 : _error$validationErro.some(_ref5 => {
      let {
        field
      } = _ref5;
      return field === 'shippingDestination.subdivision' || field === 'shippingDestination';
    });
  })) != null ? _calculationErrors$ca : false;
}
export function hasZipCodeShippingError(_ref6) {
  var _calculationErrors$ca3, _calculationErrors$ca4;
  let {
    calculationErrors
  } = _ref6;
  return (_calculationErrors$ca3 = calculationErrors == null || (_calculationErrors$ca4 = calculationErrors.carrierErrors) == null || (_calculationErrors$ca4 = _calculationErrors$ca4.errors) == null ? void 0 : _calculationErrors$ca4.some(_ref7 => {
    var _error$validationErro2;
    let {
      error
    } = _ref7;
    return error == null || (_error$validationErro2 = error.validationError) == null || (_error$validationErro2 = _error$validationErro2.fieldViolations) == null ? void 0 : _error$validationErro2.some(_ref8 => {
      let {
        field
      } = _ref8;
      return field === 'postalCode';
    });
  })) != null ? _calculationErrors$ca3 : false;
}
//# sourceMappingURL=calculationError.utils.js.map